import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PurchaseOption } from 'src/app/shared/models/app-models/PurchaseOption.model';
import { Router } from '@angular/router';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import { Subject, takeUntil } from 'rxjs';
import { PurchaseTypeMap } from 'src/app/shared/models/app-models/Approving.model';
import { EnabledPurchaseTypes } from '../../../data/constants/Data';
import { pageName } from 'src/app/shared/services/page.service';
@Component({
  selector: 'app-option-box',
  templateUrl: './option-box.component.html',
  styleUrls: ['./option-box.component.scss'],
})
export class OptionBoxComponent implements OnInit, OnDestroy {
  @Input() option: PurchaseOption = new PurchaseOption();
  enabledPurchaseTypes = EnabledPurchaseTypes;
  purchaseTypeMap = PurchaseTypeMap;
  enabled: boolean = false;
  hover: boolean = false;
  readonly permissionData$;
  destroy$: Subject<boolean> = new Subject()
  constructor(private router: Router, private permissionsService:PermissionsService) {
    this.permissionData$ = this.permissionsService.getService().pipe(takeUntil(this.destroy$))
  }
  ngOnDestroy(): void {
    this.destroy$.next(true)
    this.destroy$.unsubscribe()
  }
  ngOnInit(): void {
    console.log("option",this.option)
    if (this.option.redirectRoute != '' || !this.option.isRedirect) {
      this.enabled = true;
    } 
  }

  onClickRedirect(): void {
    sessionStorage.setItem('fromPage', pageName.Purchase_mode);
    if (this.option.isRedirect) {
      console.log("called here")
      this.router.navigate([`${this.option.redirectRoute}`]);
    } else {
      console.log("called");
      this.option.clickFunction();
    }
  }
}
